var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-progress-linear',{attrs:{"buffer-value":"0","color":"light-blue","height":"10","stream":"","value":_vm.value,"striped":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }